import { z } from "zod";

export const RequestNotificationLevelSchema = z.enum([
  "EVERY_UPDATE",
  "OWN_LEVEL",
  "REQUESTED_AND_FULLY_APPROVED",
  "APPROVED_ONLY",
]);

export type RequestNotificationLevel = z.infer<
  typeof RequestNotificationLevelSchema
>;
